import React from "react";
import ReactModal from "react-modal";
import Loader from "../../../common/loader.jsx";
import axios, {
  errorHandler,
  responseHandler,
} from "../../../requests/axios.js";
import { toast } from "react-toastify";
import DataTable from "../../../components/data-table/data-table.jsx";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

export default function AttachProviderToChannelDialog({
  onClose,
  onConfirm,
  isOpen,
  channelId,
}) {
  const [isLoading, setLoading] = React.useState(false);
  const [linkIds, setLinkIds] = React.useState([]);
  const [error, setError] = React.useState("");

  const fetchLinkIds = React.useCallback(() => {
    axios
      .get(`api/channels/${channelId}/providers`)
      .then(
        responseHandler((resp) =>
          setLinkIds(resp.data.map((provider) => provider.provider_id))
        )
      )
      .catch(
        errorHandler((e) => {
          console.error(e);
          toast.error("Error fetching Provider Ids");
        })
      );
  }, [channelId]);

  React.useEffect(() => {
    fetchLinkIds();
  }, [fetchLinkIds]);

  function onSubmit(providerId) {
    setLoading(true);
    axios
      .post(`api/channels/${channelId}/providers/${providerId}`)
      .then(
        responseHandler(() => {
          toast.success("Provider linked to Channel");
          onConfirm();
          fetchLinkIds();
        })
      )
      .catch(
        errorHandler((err) => {
          console.error(err);
          setError("Something went wrong while contacting the server");
        })
      )
      .finally(() => {
        setLoading(false);
      });
  }

  const columns = [
    {
      label: "Provider Name",
      key: "provider_name",
      value: "provider_name",
      width: 30,
    },
    {
      label: "Label",
      key: "provider_label",
      value: "provider_label",
      width: 30,
    },
    {
      label: "External Reference",
      key: "external_reference",
      value: "external_reference",
      width: 25,
    },
    {
      label: "",
      value: "",
      key: "0",
      width: 15,
      renderValue: (row) => {
        return !linkIds.find((id) => id === row.provider_id) ? (
          <span className="data-table__action-cell">
            <button
              className="btn btn--icon"
              onClick={() => onSubmit(row.provider_id)}
              aria-label="Link Provider to Channel"
              data-balloon-pos="left"
            >
              <AddRoundedIcon />
            </button>
          </span>
        ) : null;
      },
    },
  ];

  return (
    <ReactModal isOpen={isOpen} onRequestClose={onClose} ariaHideApp={false}>
      <div className="v-react-modal__inner modal-width modal-width--larger">
        <div className="v-react-modal__heading">Select Provider to link</div>
        <div className="v-react-modal__body v-react-modal__body--table-container modal-body">
          {error ? (
            <p className="u-fc--warning">{error}</p>
          ) : (
            <DataTable url={`api/providers`} columns={columns} />
          )}
        </div>
        <div className="v-react-modal__footer">
          {isLoading ? (
            <Loader width={45} height={45} />
          ) : (
            <React.Fragment>
              <button
                className="btn btn--primary"
                onClick={onClose}
                key="close"
              >
                Close
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    </ReactModal>
  );
}
